import React from 'react';
import { Label } from './ui/label';
import { Input } from './ui/input';
import {
  Facebook, Instagram, Music2, Linkedin, Search, Youtube, Briefcase,
  Newspaper, Users, Truck, UserCheck, HelpCircle
} from 'lucide-react';

export const SOURCES = [
  { value: 'Facebook', icon: Facebook },
  { value: 'Instagram', icon: Instagram },
  { value: 'TikTok', icon: Music2 },
  { value: 'LinkedIn', icon: Linkedin },
  { value: 'Google Search', icon: Search },
  { value: 'YouTube', icon: Youtube },
  { value: 'Indeed', icon: Briefcase },
  { value: 'Craigslist', icon: Newspaper },
  { value: 'Friend / Referral', icon: Users },
  { value: 'Existing Driver', icon: Truck },
  { value: 'Existing Employee', icon: UserCheck },
  { value: 'Other', icon: HelpCircle },
];

/**
 * SourceSection — renders the "Where did you hear about us?" question with conditional fields.
 * Props: value (string), onChange(patch), referralName, referralPhone, otherSource, SectionHead, num
 */
const SourceSection = ({ value, referralName, referralPhone, otherSource, onChange, SectionHead, num }) => {
  const showReferralName = ['Friend / Referral', 'Existing Driver', 'Existing Employee'].includes(value);
  const showReferralPhone = ['Friend / Referral', 'Existing Driver'].includes(value);
  const phoneRequired = value === 'Friend / Referral';
  const showOther = value === 'Other';

  return (
    <>
      {SectionHead && <SectionHead num={num} title="Where did you hear about us?" subtitle="This helps us understand which channels bring the best candidates." />}
      <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 gap-2 mb-6">
        {SOURCES.map(s => {
          const Icon = s.icon;
          const active = value === s.value;
          return (
            <button
              key={s.value}
              type="button"
              onClick={() => onChange({ source: s.value })}
              className={`text-left border rounded-xl px-3 py-3 transition-all flex items-center gap-2 ${active ? 'border-[#2AA8E8] bg-[#EFF8FD]' : 'border-[#E5EAF2] hover:border-[#0A1628]/30'}`}
            >
              <Icon className={`w-4 h-4 shrink-0 ${active ? 'text-[#2AA8E8]' : 'text-[#4A5A72]'}`} />
              <span className="font-semibold text-xs navy-text truncate">{s.value}</span>
            </button>
          );
        })}
      </div>

      {(showReferralName || showReferralPhone || showOther) && (
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-6 p-4 bg-[#F7F9FC] rounded-xl border border-[#E5EAF2]">
          {showReferralName && (
            <div>
              <Label>
                {value === 'Existing Driver' ? 'Driver name' : value === 'Existing Employee' ? 'Employee name' : 'Friend\u2019s full name'}
                <span className="text-[#D4A24C]"> *</span>
              </Label>
              <Input className="mt-1.5 h-11" value={referralName || ''} onChange={e => onChange({ referralName: e.target.value })} placeholder="Full name" />
            </div>
          )}
          {showReferralPhone && (
            <div>
              <Label>
                {value === 'Existing Driver' ? 'Driver phone' : 'Friend\u2019s phone'}
                {phoneRequired && <span className="text-[#D4A24C]"> *</span>}
              </Label>
              <Input type="tel" className="mt-1.5 h-11" value={referralPhone || ''} onChange={e => onChange({ referralPhone: e.target.value })} placeholder="(555) 000-0000" />
            </div>
          )}
          {showOther && (
            <div className="md:col-span-2">
              <Label>Please specify <span className="text-[#D4A24C]">*</span></Label>
              <Input className="mt-1.5 h-11" value={otherSource || ''} onChange={e => onChange({ otherSource: e.target.value })} placeholder="e.g. Trucking podcast, industry event…" />
            </div>
          )}
        </div>
      )}
    </>
  );
};

export default SourceSection;
